// material-ui
import { alpha } from '@mui/material/styles';

/**
 * Visual depth polish (modals, tables): backdrop, shadows, hairline borders.
 * Set to `false` to restore the previous look in one place.
 */
export const VISUAL_DEPTH_V2 = true;

/**
 * @param {import('@mui/material/styles').Theme} theme
 */
export function getVisualDepth(theme) {
  const isDark = theme.palette.mode === 'dark';

  if (!VISUAL_DEPTH_V2) {
    return {
      dialogBackdropAlpha: 0.7,
      dialogPaperShadow: '0 12px 30px rgba(0,0,0,0.12)',
      dialogPaperBorder: '1px solid rgba(0,0,0,0.06)',
      dialogPaperBackground: '#F9FAFB',
      dialogLeftAccent: '3px solid #E5E7EB',
      dialogSectionBorder: null,
      tableLift: false,
      tableCellBorderColor: null
    };
  }

  if (isDark) {
    return {
      dialogBackdropAlpha: 0.82,
      dialogPaperShadow: `0 28px 72px rgba(0,0,0,0.65), 0 14px 36px rgba(0,0,0,0.45), 0 0 0 1px ${alpha('#fff', 0.08)}`,
      dialogPaperBorder: `1px solid ${alpha('#fff', 0.16)}`,
      dialogPaperBackground: theme.palette.background.paper,
      dialogLeftAccent: `3px solid ${alpha('#fff', 0.28)}`,
      dialogSectionBorder: alpha('#fff', 0.2),
      tableLift: true,
      tableContainerShadow: '0 4px 12px rgba(0,0,0,0.35)',
      tableContainerBorder: `1px solid ${alpha('#fff', 0.12)}`,
      tableCellBorderColor: theme.palette.divider
    };
  }

  return {
    dialogBackdropAlpha: 0.58,
    dialogPaperShadow:
      '0 28px 72px rgba(0,0,0,0.24), 0 14px 36px rgba(0,0,0,0.14), 0 0 0 1px rgba(0,0,0,0.06)',
    dialogPaperBorder: '1px solid rgba(0,0,0,0.12)',
    dialogPaperBackground: '#FFFFFF',
    dialogLeftAccent: '3px solid #94A3B8',
    dialogSectionBorder: '#CBD5E1',
    tableLift: true,
    tableContainerShadow: '0 4px 12px rgba(0,0,0,0.06)',
    tableContainerBorder: '1px solid #D1D5DB',
    tableCellBorderColor: '#D1D5DB'
  };
}
